"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var snorlaxEgg = {
    name: "snorlax",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["s", "n", "o", "r", "l", "a", "x"],
        captureOnInputs: false
    },
    onStart: function () {
        var data = "https://i.imgur.com/3T3Lico.gif";
        var shock = document.createElement("div");
        var img = new Image();
        img.src = data;
        img.style.width = "374px";
        img.style.height = "375px";
        img.style.transition = "13s all";
        img.style.position = "fixed";
        img.style.right = "-374px";
        img.style.bottom = "-10px";
        img.style.zIndex = "999999";
        document.body.appendChild(img);
        window.setTimeout(function () {
            img.style.right = "calc(100% + 500px)";
        }, 50);
        // window.setTimeout(function(){
        //   img.style.right = 'calc(100% + 375px)';
        // }, 4500);
        window.setTimeout(function () {
            img.parentNode.removeChild(img);
        }, 10300);
    },
};
exports.default = snorlaxEgg;
